import { Box, Button, Chip } from '@mui/material';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { SearchContext } from 'context/SearchContext';

export const ClearFilterSection = () => {
  const {
    request: searchRequest,
    clearAllFilters,
    handleToggleFilter
  } = useContext(SearchContext);
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: theme.spacing(1)
      })}
    >
      <Button
        variant="text"
        onClick={clearAllFilters}
        endIcon={<CloseIcon />}
        sx={{ whiteSpace: 'nowrap' }}
        size="small"
      >
        Clear filters
      </Button>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          flexWrap: 'wrap',
          ml: '3px'
        }}
      >
        {searchRequest?.filters?.map(filter => (
          <Chip
            key={filter.value}
            label={filter.value}
            onDelete={() => {
              handleToggleFilter(filter.value, filter.field);
            }}
            variant="outlined"
            size="small"
            color="secondary"
          />
        ))}
      </Box>
    </Box>
  );
};
